// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1X7LI","header":"styles_header__nS-38"};